// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseButton-root-297ms","keyboardFocus":"BaseButton-keyboardFocus-1UqY7","mouseHover":"BaseButton-mouseHover-3wvh0"};